import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { useCampaignTypesOptionsWithPermissions, useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { getSocialMediaText } from '@anytag/shared-utils';
import { InfluencerProfileCampaignsFilterFormKeys } from './schemaTypes';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const allCampaignTypes = useCampaignTypesOptionsWithPermissions();
  const allCampaignTypeOptions = useTranslateOptions(allCampaignTypes);
  const socialMediaOptions = [
    SupportedSocialMediaType.FACEBOOK,
    SupportedSocialMediaType.INSTAGRAM,
    SupportedSocialMediaType.INSTAGRAM_STORY,
    SupportedSocialMediaType.TWITTER,
    SupportedSocialMediaType.YOUTUBE,
    SupportedSocialMediaType.TIKTOK,
    SupportedSocialMediaType.DOUYIN,
    SupportedSocialMediaType.THREADS
  ].map((campaignType) => ({ label: getSocialMediaText(campaignType), value: campaignType }));

  return (
    <Form.Fields className="max-w-[80%]">
      <TextSearchField<InfluencerProfileCampaignsFilterFormKeys>
        name="keyword"
        title="Keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.PostContent')}
      />
      <SelectorField<InfluencerProfileCampaignsFilterFormKeys>
        name="campaignType"
        clearable={false}
        onSubmit={onSubmit}
        className="max-w-60"
        options={allCampaignTypeOptions}
        title={t('Selector.Campaign Type')}
      />
      <SelectorField<InfluencerProfileCampaignsFilterFormKeys>
        name="socialMedias"
        onSubmit={onSubmit}
        className="max-w-60"
        options={socialMediaOptions}
        title={t('Selector.Social Media')}
        multiple
      />
    </Form.Fields>
  );
};
